/**
 * Волна B (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute path='/service_courier'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import JobCourierPage from '@routes/JobCourier';

export const Route = createFileRoute('/service_courier')({
  staticData: { layout: { withoutHeader: true, withoutFooter: true } },
  component: () => (
    <CacheDataRoute component={JobCourierPage} path='/service_courier' />
  )
});
